import { $api } from "../../../../../services/request.config";
import { getErrorNotificationContentAction } from "../getErrorNotificationContent.action";

export const sendRequestsDelegation =
    (
        delegationState,
        setIsLoading,
        setModalSuccess,
        setNotification,
    ) => async (dispatch) => {
        try {
            setIsLoading(true);
            const response = await $api.post("v1/manager/delegations", delegationState);
            if (response.status === 200) {
                setModalSuccess(true);
            }
            setIsLoading(false);
        } catch (error) {
            console.log(error, "error");
            console.log(error.response, "error response");
            setIsLoading(false);
            if (error.response.status === 409) {
                const { errors } = error.response.data;
                if (errors) {
                    const arrOfErrors = [];
                    for (const key in errors) {
                        errors[key].forEach(e => arrOfErrors.push(e));
                    }
                    dispatch(getErrorNotificationContentAction(arrOfErrors));
                    setNotification(true);
                }
            } else if (error.response.status === 422) {
                const { errors } = error.response.data;
                if (errors) {
                    const arrOfErrors = [];
                    for (const key in errors) {
                        errors[key].forEach(e => arrOfErrors.push(e));
                    }
                    dispatch(getErrorNotificationContentAction(arrOfErrors));
                    setNotification(true);
                }
            }  else if (error.response.status >= 400) {
                setNotification(true);
                dispatch(getErrorNotificationContentAction(["Произошла ошибка создания делегирования."]));
            } else if (error.response.status >= 500) {
                setNotification(true);
                dispatch(getErrorNotificationContentAction(["Произошла ошибка создания делегирования."]));
            }
        }
    };
